import { faBars } from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';
import Link from 'next/link';
import { useCallback, useRef, useState } from 'react';
import buttonStyles from '../styles/Button.module.css';
import styles from '../styles/Header.module.css';
import { MenuGroup, MenuLink } from '../types';
import Icon from './Icon';
import Menu from './Menu';

const logoSize = 32;

interface HeaderProps {
  h1: string;
  menu: MenuLink[];
  keyboardGroups: MenuGroup[];
}

const Header = (props: HeaderProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { h1, menu, keyboardGroups } = props;
  const openButtonRef = useRef<HTMLButtonElement | null>(null);
  // Closing the menu puts the focus back on the button that opened it
  const closeMenu = useCallback(() => {
    setMenuOpen(false);
    openButtonRef.current?.focus();
  }, []);
  return (
    <header className={styles.header}>
      <div className={styles.headerWrapper}>
        <Link href="/" prefetch={false} className={styles.homeLink}>
          <Image src="/language-keyboard-logo.svg" alt="Language keyboard logo" width={logoSize} height={logoSize} />
        </Link>
        <h1 className={styles.title}>{h1}</h1>
        <Menu menuOpen={menuOpen} menu={menu} keyboardGroups={keyboardGroups} closeMenu={closeMenu} />
        <button
          ref={openButtonRef}
          onClick={() => setMenuOpen(true)}
          className={buttonStyles.menuButton}
          aria-label="Open menu"
          aria-expanded={menuOpen}
          aria-controls="site-menu"
        >
          <Icon icon={faBars} size="2x" />
        </button>
      </div>
    </header>
  );
};

export default Header;
